module.exports = __webpack_public_path__ + "img/c0cdf1f.png";